import { IDTO } from '../../../core/domain';

export enum FormType {
  AnnualDeclaration = 'AnnualDeclaration',
  EndOfPractice = 'EndOfPractice',
  Amalgamation = 'Amalgamation',
}

export enum FormStatus {
  Initial = 'Initial', InProgress = 'InProgress', Completed = 'Completed', Payed = 'Payed'
}

export class FormDefinition implements IDTO {
  id: number;
  societeId: string;
  declarationYear: number;
  formType: FormType;
  status: FormStatus;
  data: any;
  pdfLoading: boolean;

  static get empty(): FormDefinition {
    return {
      id: 0,
      societeId: '',
      declarationYear: 0,
      formType: FormType.Amalgamation,
      status: FormStatus.Initial,
      pdfLoading: false,
      data: {},
    };
  }
}

export class CompanySelector implements IDTO {
  id: string;
  legalName: string;
  legalEntityNumber: string;
}

export class Company implements IDTO {
  id: string;
  name: string;
}
